import { ACOVPItem } from "./ACOVPItem";
export class ACOVPList {
	private aList: any[];
	constructor() {
		this.aList = new Array();
	}
	public addACOVP(_sItemNo: string, _iCnt: number): void {
		var acovpitemTmp: ACOVPItem;
		acovpitemTmp = new ACOVPItem(null);
		acovpitemTmp.iCnt = _iCnt;
		acovpitemTmp.sItemNo = _sItemNo;
		this.aList.push(acovpitemTmp);
	}
	public length(): number {
		return this.aList.length;
	}
	public getItemByIndex(_i: number): ACOVPItem {
		if (_i >= 0 && _i < this.aList.length) {
			return new ACOVPItem(this.aList[_i]);
		}
		return new ACOVPItem(null);
	}
	public removeAll(): void {
		this.aList = new Array();
	}
}